/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Footer_Madewithprefix2Inputs */

const ja_playdata_footer_madewithprefix2 = /** @type {(inputs: Playdata_Footer_Madewithprefix2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Made with`)
};

const en_playdata_footer_madewithprefix2 = /** @type {(inputs: Playdata_Footer_Madewithprefix2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Made with`)
};

/**
* | output |
* | --- |
* | "Made with" |
*
* @param {Playdata_Footer_Madewithprefix2Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const playdata_footer_madewithprefix2 = /** @type {((inputs?: Playdata_Footer_Madewithprefix2Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Footer_Madewithprefix2Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_footer_madewithprefix2(inputs)
	return en_playdata_footer_madewithprefix2(inputs)
});
export { playdata_footer_madewithprefix2 as "playdata_footer_madeWithPrefix" }